<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<app-header></app-header>

<div class="container3 cent" style="width:100%; margin-top:60px" *ngIf="users">
	<div class="row" style="margin-top:5px;margin-bottom:5px">

					<div class="col-sm-12 col-xs-12 col-md-4 col-lg-3 col-xl-3   pull-left" >
							<div id="tg-content" class="tg-content tg-dashboard nav-collapse"
							id="navigation"  >
						<div class="tg-widgetdashboard"  >
							<div class="tg-widgetprofile">
								<figure class="tg-directpostimg"> <a><img src="https://passport.petcart.in/images/userimgs/{{users[0].image}}"

									alt="image description" ></a>
								</figure>

								<div class="tg-directposthead">
										<div class="row " *ngIf="flag == 0">
												<div class="col-12 text-center">
														<input type="file" style="text-align:center" ngFileSelect [options]='options' (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)">
												</div>

											</div>
									<h3 style="color:#76542a;">{{users[0].name}}</h3>
                  <div class="tg-subjects" style="color:#9b7544; overflow-wrap:break-word">{{users[0].bio}}</div>
                  <div class="tg-subjects" style="color:#9b7544; overflow-wrap:break-word">email: {{users[0].email}}</div>
                  <div class="tg-subjects" style="color:#9b7544; overflow-wrap:break-word">mobile no.: {{users[0].mobile}}</div>
									<a class="btn btn-success" (click)="openDialog(users[0].name,users[0].mobile,users[0].bio)">Edit Profile</a>
                  <div class="tg-subjects" style="color:#9b7544; overflow-wrap:break-word;text-decoration: underline; cursor: pointer; "
                  *ngIf="vflag == 0" (click)="verifyMobile()">
                    <strong>Verify Your Mobile number</strong>
                    </div>
                    <div class="tg-subjects" style="color:#76542a; overflow-wrap:break-word; cursor: pointer; text-decoration: underline" (click)=" changepassword()">
                        <strong>Change password</strong>
                        </div>
								</div>
								 </div>
							<nav id="tg-dashboardnav" class="tg-dashboardnav">
								<ul style="list-style:none;color:#000;     padding-left: 25px;">
									<li style="height: 25px;"> <a style="color: #9b7544" routerLink='/manageprofile/order'> <i class="fa fa-book"></i> <span><b>Order History</b></span> </a> </li>
									<li style="height: 25px;"> <a style="color: #9b7544" routerLink='/manageprofile/appointment'> <i class="fa fa-check"></i> <span> <b>My Appointments</b></span> </a> </li>
									<li style="height: 25px;"> <a style="color: #9b7544" routerLink='/manageprofile/manageyourpet'> <i class="fa fa-user"></i> <span> <b>My Pet Info</b></span> </a> </li>
									<li style="height: 25px;"> <a style="color: #9b7544" routerLink='/manageprofile/useraddress/manageprofile'> <i class="fa fa-location-arrow"></i> <span> <b>Manage Address</b></span> </a> </li>
									<li style="height: 25px;"> <a style="color: #9b7544" routerLink="/chats"> <i class="fa fa-envelope-open"></i> <span> <b>Chat History</b></span> </a> </li>
									<li style="height: 25px;" class="tg-successmessage"> <a style="color: #9b7544" routerLink='/manageprofile/adoption'> <i class="fa fa-calendar"></i> <span> <b>Adoption History </b></span> </a> </li>
									<li style="height: 25px;" (click)="logOut()"> <a style="color:#9b7544;"> <i class="fa fa-server"></i> <span><b>Logout</b></span> </a> </li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
					<div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 pull-right">
						<div class="tg-dashboardtabs" >
							<router-outlet></router-outlet>
							</div>
							</div>
	</div>
</div>

<div class="footer">
  <app-footer></app-footer>
</div>
